import { ComponentProps } from "react";
import * as S from "./styles";
interface ITextAreaProps extends ComponentProps<"textarea"> {
  label?: string;
}

export const TextArea = ({ label, ...rest }: ITextAreaProps) => {
  return (
    <S.TextAreaLabel>
      <span>{label}</span>
      <textarea {...rest} />
    </S.TextAreaLabel>
  );
};
